<div class="container mt-3">
  <h1 class="mb-3">My profile</h1>

  <div class="card mat-elevation-z8 p-4">
    <div class="card-header">Profile Settings</div>
    <div class="card-body">
      <div class="row">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>First name</mat-label>
          <input matInput placeholder="First name" type="text" name="first-name" id="itemFirstName" [(ngModel)]="item.first_name" cdkFocusInitial required>
        </mat-form-field>
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Last name</mat-label>
          <input matInput placeholder="Last name" type="text" name="last-name" id="itemLastName" [(ngModel)]="item.last_name" required>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" type="email" name="email" id="email" [(ngModel)]="item.email" required>
        </mat-form-field>
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Phone</mat-label>
          <input matInput placeholder="Phone" type="text" name="phone" id="phone" [(ngModel)]="item.phone">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col" appearance="outline">
          <mat-label>Job role</mat-label>
          <input matInput placeholder="Job role" name="job" [(ngModel)]="item.job_description">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput placeholder="Password" type="password" name="product-name" id="password" autocomplete="off" [(ngModel)]="item.password">
        </mat-form-field>
        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Password confirm</mat-label>
          <input matInput placeholder="Password confirm" type="password" name="product-name" id="password_confirm" [(ngModel)]="item.password_confirm">
        </mat-form-field>
      </div>
      <button mat-flat-button color="primary" (click)="onSaveClick()" >
        <span class="navigation-button">Save</span>
      </button>
    </div>
  </div>

  <div class="card mat-elevation-z8 p-4 mt-4">
    <div class="card-header">My House Views</div>
    <div class="card-body">
      <app-house-views-setter mode="user" [views]="userHouseViews"></app-house-views-setter>
    </div>
  </div>
</div>
